module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_correct-f007f8915a875932ff70431cff0d48e6.svg";